export const abdmintegratorRouteDef = [
]
